module.exports = __webpack_public_path__ + "img/platformFront.7603c96c.png";